/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const HeartbeatResponseParser = /* #__PURE__ */ parsers.object([
    ['expiresAt', parsers.moment, 'expires_at'],
]);
export class HeartbeatResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return HeartbeatResponseParser.decode(input).map(res => new HeartbeatResponse(res));
    }
    static unsafeDecode(input) {
        return HeartbeatResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return HeartbeatResponseParser.encode(data);
    }
    static schema() {
        return HeartbeatResponseParser.schema();
    }
}
